export default "__VITE_ASSET__C1h70bf4__"